import React, { useState, useEffect } from "react";
import Alert from "@material-ui/lab/Alert";
import moment from "moment";
// I18n
import { useTranslation } from "react-i18next";
import { makeStyles, withStyles, Box } from "@material-ui/core";
import PropTypes from "prop-types";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import { timeConfig, dateConfig } from "config";
import { isEmptyObject, properCase } from "utils";

const useStyles = makeStyles({
  full: {
    display: "flex",
    alignItems: "center",
  },
  tansactional: {
    color: "#1B75BC",
  },
  nonTransactional: {
    color: "#00A88E",
  },
  project: {
    color: "#6DCFF6",
  },
  buildingMoves: {
    color: "#3C5772",
  },
  meal: {
    color: "#58595B",
  },
  startTime: {
    fontWeight: "bold",
  },
});

// Customised MUI Table components

const TableHeadCustom = withStyles((theme) => ({
  root: {
    backgroundColor: "#3c5772", //TODO
    border: "none",
  },
}))(TableHead);

const TableHeaderCell = withStyles((theme) => ({
  root: {
    color: "white",
    borderBottom: "none",
    border: "none",
  },
}))(TableCell);

const TableCellCustom = withStyles({
  root: {
    borderBottom: "none",
  },
})(TableCell);

const ClockedIn2 = (props) => {
  const { data } = props,
    { t } = useTranslation(),
    classes = useStyles(),
    // Non Integrated
    // punches = data != null && data != undefined ? data : [];
    // Integrated
    punches = data != null && data != undefined ? data : {};

  console.log("CLOCKED IN DATA ", punches, data, isEmptyObject(punches));

  const activityGroupClass = (activityGroup) => {
    switch (activityGroup) {
      case "Transactional":
        return classes.tansactional;

      case "Non-Transactional":
        return classes.nonTransactional;

      case "Project":
        return classes.project;

      case "Building Moves":
        return classes.buildingMoves;

      case "Meal":
        return classes.meal;

      default:
        return {};
    }
  };

  useEffect(() => {
    console.log(data);
  }, [data]);

  // Non Integrated

  // return (
  //   <>
  //     {punches.length > 0 ? (
  //       <TableContainer>
  //         <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
  //           <TableHeadCustom>
  //             <TableRow>
  //               <TableHeaderCell>{t("pgHome.lblName")}</TableHeaderCell>
  //               <TableHeaderCell align="left">
  //                 {properCase(t("pgHome.lblActivityName"))}
  //               </TableHeaderCell>
  //               <TableHeaderCell align="left">
  //                 {properCase(t("pgHome.lblJobFamily"))}
  //               </TableHeaderCell>
  //               <TableHeaderCell align="right">
  //                 {properCase(t("pgHome.lblTimeStamp"))}
  //               </TableHeaderCell>
  //               <TableHeaderCell align="right">
  //                 {properCase(t("pgHome.lblDuration"))}
  //               </TableHeaderCell>
  //             </TableRow>
  //           </TableHeadCustom>
  //           <TableBody>
  //             {punches.map((punch) => (
  //               <TableRow key={punch.name}>
  //                 <TableCellCustom component="th" scope="row">
  //                   {punch.name}
  //                 </TableCellCustom>
  //                 <TableCellCustom
  //                   className={activityGroupClass(punch.activity)}
  //                   align="left"
  //                 >
  //                   {punch.activity}
  //                 </TableCellCustom>
  //                 <TableCellCustom align="left">
  //                   {punch.jobFamily}
  //                 </TableCellCustom>
  //                 <TableCellCustom align="right" className={classes.startTime}>
  //                   {moment(punch.startTime).format(dateConfig.format2) +
  //                     " " +
  //                     moment(punch.startTime).format(timeConfig.format3)}
  //                 </TableCellCustom>
  //                 <TableCellCustom align="right">
  //                   {punch.duration}
  //                 </TableCellCustom>
  //               </TableRow>
  //             ))}
  //           </TableBody>
  //         </Table>
  //       </TableContainer>
  //     ) : (
  //       <>
  //         <Box className={classes.full}>
  //           <Alert severity="info" style={{ width: "100%" }}>
  //             {t("pgHome.errNoReportData2")}
  //           </Alert>
  //         </Box>
  //       </>
  //     )}
  //   </>
  // );

  // INTEGRATED

  return (
    <>
      {!isEmptyObject(punches) ? (
        <TableContainer>
          <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
            <TableHeadCustom>
              <TableRow>
                <TableHeaderCell>{t("pgHome.lblName")}</TableHeaderCell>
                <TableHeaderCell align="left">
                  {properCase(t("pgHome.lblActivityName"))}
                </TableHeaderCell>
                <TableHeaderCell align="left">
                  {properCase(t("pgHome.lblJobFamily"))}
                </TableHeaderCell>
                <TableHeaderCell align="right">
                  {properCase(t("pgHome.lblTimeStamp"))}
                </TableHeaderCell>
                <TableHeaderCell align="right">
                  {properCase(t("pgHome.lblDuration"))}
                </TableHeaderCell>
              </TableRow>
            </TableHeadCustom>
            <TableBody>
              {Object.keys(punches).map((workerId) => {
                const punchTime = moment(punches[workerId].inTS);
                const currentTime = moment(new Date());
                const punchDuration = currentTime.diff(
                  punchTime,
                  "hours",
                  true
                );
                return (
                  <TableRow key={punches[workerId].workerName}>
                    <TableCellCustom component="th" scope="row">
                      {punches[workerId].workerName}
                    </TableCellCustom>
                    <TableCellCustom
                      className={activityGroupClass(
                        punches[workerId].activityGroup
                      )}
                      align="left"
                    >
                      {punches[workerId].activityGroup}
                    </TableCellCustom>
                    <TableCellCustom align="left">
                      {punches[workerId].jobRole}
                    </TableCellCustom>
                    <TableCellCustom
                      align="right"
                      className={classes.startTime}
                    >
                      {moment(punches[workerId].inTS).format(
                        dateConfig.format2
                      ) +
                        " " +
                        moment(punches[workerId].inTS).format(
                          timeConfig.format3
                        )}
                    </TableCellCustom>
                    <TableCellCustom align="right">
                      {punchDuration.toFixed(2)}
                    </TableCellCustom>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <>
          <Box className={classes.full}>
            <Alert severity="info" style={{ width: "100%" }}>
              {t("pgHome.errNoReportData2")}
            </Alert>
          </Box>
        </>
      )}
    </>
  );
};

ClockedIn2.propTypes = {
  data: PropTypes.array,
};

export default ClockedIn2;
